<template>
      <img :src="imageSource" 
            class="gallery-image" /> 
</template>

<script>
export default {
  name: 'ImageLoader',
  props: {
      'smallImageUrl': String,
        'bigImageUrl': String
        },
  data() {
      return {
          imageSource : this.getImgUrl(this.smallImageUrl)
      };
  },
  methods: {
    getImgUrl(picName) {
        return require('../assets/'+ picName);
    }
    },
  mounted() {
            // https://blog.theodo.com/2016/10/medium-like-image-loading-with-vue-js/
            const img = new Image();
            const that = this;
            img.onload = () => {
                that.imageSource = that.getImgUrl(that.bigImageUrl);
            };
            img.src = that.imageSource;
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
   
</style>